'use client'; // Add this line at the top

import React from 'react';
import CountUp from 'react-countup'; // Import CountUp from react-countup
import '@fortawesome/fontawesome-free/css/all.min.css';

// Import images
import counterTwoBgShape from '../../assets/images/shapes/counter-two-bg-shape.png';
import counterTwoRightBgShape from '../../assets/images/shapes/counter-two-right-bg-shape.png';

const CounterTwo = () => {
  return (
    <>
      { /* Counter Two Start */}
      <section className="counter-two">
        <div className="counter-two__wrap">
          <div
            className="counter-two__bg-shape float-bob-y"
            style={{ backgroundImage: `url(${counterTwoBgShape})` }}
          ></div>
          <div className="container">
            <div className="section-title text-center">
              <div className="section-title__tagline-box">
                <span className="section-title__tagline">why we are the best</span>
              </div>
              <h2 className="section-title__title">
                Leading the Future of <span>Scrap Processing</span> & <span>Metal Recycling</span>
              </h2>
            </div>
            <div className="row">
              <div className="col-xl-6 wow slideInLeft" data-wow-delay="100ms" data-wow-duration="2500ms">
                <div className="counter-two__left">
                  <ul className="counter-two__points-list list-unstyled">
                    <li>
                      <div className="icon">
                        <i className="fas fa-tools" style={{ color: "white", fontSize: "24px" }}></i>
                      </div>
                      <div className="content">
                        <h3>Heavy-Duty Scrap Shearing Machines</h3>
                        <p>
                          Maximize efficiency with Horizontal & Vertical Shearing Machines, engineered for TMT bars, ISPAT, and industrial metal processing.

                        </p>
                      </div>
                    </li>
                    <li>
                      <div className="icon">
                        <span className="icon-blueprint"></span>
                      </div>
                      <div className="content">
                        <h3>Industrial Scrap Shredders</h3>
                        <p>
                          Our high-performance Scrap Shredders ensure fast, precise metal breakdown, enhancing recycling processes and reducing waste.
                        </p>
                      </div>
                    </li>
                    <li>
                      <div className="icon">
                        <i className="fas fa-cogs" style={{ color: "white", fontSize: "35px" }}></i>
                      </div>
                      <div className="content">
                        <h3> Hydraulic Baler Machines</h3>
                        <p>
                          Compact and manage scrap effectively with Hydraulic Baling Machines, ideal for scrap yards, foundries, and recycling units.
                        </p>
                      </div>
                    </li>
                    <li>
                      <div className="icon">
                        <i className="fas fa-industry" style={{ color: "white", fontSize: "35px" }}></i>
                      </div>
                      <div className="content">
                        <h3> Complete Scrap Processing Solutions</h3>
                        <p>
                          From shearing to shredding, baling, and sorting, we deliver end-to-end solutions for steel plants, metal recycling units, and industrial scrap yards.
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-xl-6 wow slideInRight" data-wow-delay="100ms" data-wow-duration="2500ms">
                <div className="counter-two__right">
                  <div
                    className="counter-two__right-bg-shape"
                    style={{ backgroundImage: `url(${counterTwoRightBgShape})` }}
                  ></div>
                  <div className="column">
                    {/* Counter Two Single Start */}
                    <div className="col-xl-12 col-lg-8 col-md-8">
                      <div className="counter-two__single">
                        <div className="counter-two__icon">
                          <span className="icon-tools"></span>
                        </div>
                        <div className="counter-two__count-box d-flex ">
                          <div className="counter-two__count count-box">
                            <h3 className="count-text">
                              <CountUp end={250} duration={1.5} /> {/* Dynamic count */}
                            </h3>
                            {/* <span>k</span> */}
                            <span>+</span>
                          </div>
                          <h3 className="counter-two__count-text ">Machines Sold</h3>
                        </div>
                      </div>
                    </div>
                    {/* Counter Two Single End */}
                    {/* Counter Two Single Start */}
                    <div className="col-xl-12 col-lg-8 col-md-8">
                      <div className="counter-two__single ">
                        <div className="counter-two__icon">
                          <span className="icon-paint-roller"></span>
                        </div>
                        <div className="counter-two__count-box d-flex">
                          <div className="counter-two__count count-box">
                            <h3 className="count-text">
                              <CountUp end={200} duration={1.5} />
                            </h3>

                            <span>+</span>
                          </div>
                          <h3 className="counter-two__count-text">Our Team Member</h3>
                        </div>
                      </div>
                    </div>
                    {/* Counter Two Single End */}
                    {/* Counter Two Single Start */}
                    <div className="col-xl-12 col-lg-8 col-md-8">
                      <div className="counter-two__single">
                        <div className="counter-two__icon">
                          <span className="icon-star"></span>
                        </div>
                        <div className="counter-two__count-box  d-flex">
                          <div className="counter-two__count count-box">
                            <h3 className="count-text">
                              <CountUp end={100} duration={1.5} /> {/* Dynamic count */}
                            </h3>

                            <span>+</span>
                          </div>
                          <h3 className="counter-two__count-text">Clients Reviews</h3>
                        </div>
                      </div>
                    </div>

                    <div className="col-xl-12 col-lg-8 col-md-8">
                      <div className="counter-two__single">
                        <div className="counter-two__icon">
                          <span className="icon-architect"></span>
                        </div>
                        <div className="counter-two__count-box d-flex">
                          <div className="counter-two__count count-box">
                            <h3 className="count-text">
                              <CountUp end={90} duration={1.5} /> {/* Dynamic count */}
                            </h3>

                            <span>+</span>
                          </div>
                          <h3 className="counter-two__count-text">In-House Service Engineers</h3>
                        </div>
                      </div>
                    </div>
                    {/* Counter Two Single End */}
                    {/* Counter Two Single Start */}
                    {/* <div className="col-xl-6 col-lg-6 col-md-6">
                      <div className="counter-two__single">
                        <div className="counter-two__icon">
                          <span className="icon-stairs"></span>
                        </div>
                        <div className="counter-two__count-box">
                          <div className="counter-two__count count-box">
                            <h3 className="count-text">
                              <CountUp end={7} duration={1.5} /> 
                            </h3>
                            <span>k</span>
                            <span>+</span>
                          </div>
                          <p className="counter-two__count-text">Our Winning Award</p>
                        </div>
                      </div>
                    </div> */}
                    {/* Counter Two Single End */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      { /* Counter Two End */}
    </>
  );
};

export default CounterTwo;
